// https://github.com/facebook/react/issues/14010#issuecomment-433788147
import Dashboard from 'assets/js/classes/Dashboard'
import handleToast from './handleToast'

// eventBucketUpdated(data, modelContext, toastsContext)
export default function eventBucketCreated({ author, user, bucket }, contexts, { toasts, toastsDispatch, updateToasts }) {
  if (author?.id === user?.id) return;  // Don't throw toast.
  
  contexts.forEach( ({ dataset, dispatch, prop, update }) => {
    Dashboard.eventBucketCreated(bucket, dataset);
    update(dispatch, { [prop]: dataset });
  });

  handleToast({
    title: 'Dashboard Created', 
    message: `Dashboard "${bucket?.title}" was created by ${author?.name} (${author?.email}). The latest version has automatically been loaded for you.`,
    autohide: true, 
  }, { toasts, toastsDispatch, updateToasts });
}